let messaages_de = {
	Salutation: {
		required: 'Bitte wählen Sie eine Anrede.',
	},
	FirstName: {
		required: 'Bitte geben Sie einen Vornamen ein.',
	},
	LastName: {
		required: 'Bitte geben Sie einen Nachnamen ein.',
	},
	Email: {
		required: 'Bitte geben Sie eine E-Mail-Adresse ein.',
		email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
	},
	Country: {
		required: 'Bitte wählen Sie ein Land aus.',
	},
	Postcode: {
		required: 'Bitte wählen Sie eine Postleitzahl aus.',
	},
	Password: {
		required: 'Bitte geben Sie ein Passwort ein.',
	},
	ConfirmPassword: {
		required: 'Bitte geben Sie ein Passwort ein, um es zu bestätigen.',
		equalTo: 'Bitte stellen Sie sicher, dass die Passwörter übereinstimmen.',
	},
	TermsAndConditions: {
		required: 'Bitte stimmen Sie den Allgemeinen Geschäftsbedingungen zu.',
	}
};

export function messages_de() {
	return messaages_de;
}
